import * as React from "react";
import { useCallback } from "react";
import { useField } from "formik";
import { Spinner } from "components/common";
import { useGetEventProcedure } from "security-app/hooks/useEventProceduresAPI";
import Form from "./Form";
import { INIT_EVENT_PROCEDURE } from "./utils";
function EventProcedureFormField({ field, onClose, remediationSteps = void 0, onRemove = void 0 }) {
  const [{ value: eventProcedureId }, _m, { setValue, setTouched }] = useField({ name: field.name });
  const { eventProcedure, loadingEventProcedure } = useGetEventProcedure(eventProcedureId);
  const onChange = useCallback(
    (newEventProcedureId) => {
      setValue(newEventProcedureId);
      setTouched(true);
      onClose(newEventProcedureId);
    },
    [setTouched, setValue, onClose]
  );
  const handleRemove = useCallback(() => {
    setValue("");
    setTouched(true);
    onRemove == null ? void 0 : onRemove();
  }, [onRemove, setTouched, setValue]);
  if (loadingEventProcedure) return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading" });
  if (remediationSteps) INIT_EVENT_PROCEDURE.description = remediationSteps;
  return /* @__PURE__ */ React.createElement(
    Form,
    {
      eventProcedure: eventProcedure || INIT_EVENT_PROCEDURE,
      onSave: onChange,
      onCancel: onClose,
      onDelete: handleRemove
    }
  );
}
export default EventProcedureFormField;
